"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _TextInput = _interopRequireDefault(require("@peracto/peracto-editor-ui/dist/TextInput"));

var _File = _interopRequireDefault(require("@peracto/peracto-editor-ui/dist/File"));

var _Checkbox = _interopRequireDefault(require("@peracto/peracto-editor-ui/dist/Checkbox"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var PanelsForm = function PanelsForm(_ref) {
  var _onChange = _ref.onChange,
      state = _ref.state;
  var flipped = state.flipped,
      largePanelImage = state.largePanelImage,
      largePanelImageAlt = state.largePanelImageAlt,
      largePanelImageLink = state.largePanelImageLink,
      largePanelImageLinkExternal = state.largePanelImageLinkExternal,
      smallPanelImageTop = state.smallPanelImageTop,
      smallPanelImageTopAlt = state.smallPanelImageTopAlt,
      smallPanelImageTopLink = state.smallPanelImageTopLink,
      smallPanelImageTopLinkExternal = state.smallPanelImageTopLinkExternal,
      smallPanelImageBottom = state.smallPanelImageBottom,
      smallPanelImageBottomAlt = state.smallPanelImageBottomAlt,
      smallPanelImageBottomLink = state.smallPanelImageBottomLink,
      smallPanelImageBottomLinkExternal = state.smallPanelImageBottomLinkExternal;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "mb-0 form-group"
  }, /*#__PURE__*/_react["default"].createElement(_Checkbox["default"], {
    label: "Flipped",
    checked: flipped,
    onChange: function onChange(e) {
      return _onChange({
        flipped: e.target.checked
      });
    }
  }), /*#__PURE__*/_react["default"].createElement(_File["default"], {
    label: "Large Panel Image",
    onChange: function onChange(value) {
      return _onChange({
        largePanelImage: value
      });
    },
    value: largePanelImage
  }), /*#__PURE__*/_react["default"].createElement(_TextInput["default"], {
    label: "Large Panel Image Alt",
    onChange: function onChange(e) {
      return _onChange({
        largePanelImageAlt: e.target.value
      });
    },
    value: largePanelImageAlt
  }), /*#__PURE__*/_react["default"].createElement(_TextInput["default"], {
    label: "Large Panel Image Link",
    onChange: function onChange(e) {
      return _onChange({
        largePanelImageLink: e.target.value
      });
    },
    value: largePanelImageLink
  }), /*#__PURE__*/_react["default"].createElement(_Checkbox["default"], {
    label: "External Link",
    checked: largePanelImageLinkExternal,
    onChange: function onChange(e) {
      return _onChange({
        largePanelImageLinkExternal: e.target.checked
      });
    }
  }), /*#__PURE__*/_react["default"].createElement(_File["default"], {
    label: "Small Panel Image Top",
    onChange: function onChange(value) {
      return _onChange({
        smallPanelImageTop: value
      });
    },
    value: smallPanelImageTop
  }), /*#__PURE__*/_react["default"].createElement(_TextInput["default"], {
    label: "Small Panel Image Top Alt",
    onChange: function onChange(e) {
      return _onChange({
        smallPanelImageTopAlt: e.target.value
      });
    },
    value: smallPanelImageTopAlt
  }), /*#__PURE__*/_react["default"].createElement(_TextInput["default"], {
    label: "Small Panel Image Top Link",
    onChange: function onChange(e) {
      return _onChange({
        smallPanelImageTopLink: e.target.value
      });
    },
    value: smallPanelImageTopLink
  }), /*#__PURE__*/_react["default"].createElement(_Checkbox["default"], {
    label: "External Link",
    checked: smallPanelImageTopLinkExternal,
    onChange: function onChange(e) {
      return _onChange({
        smallPanelImageTopLinkExternal: e.target.checked
      });
    }
  }), /*#__PURE__*/_react["default"].createElement(_File["default"], {
    label: "Small Panel Image Bottom",
    onChange: function onChange(value) {
      return _onChange({
        smallPanelImageBottom: value
      });
    },
    value: smallPanelImageBottom
  }), /*#__PURE__*/_react["default"].createElement(_TextInput["default"], {
    label: "Small Panel Image Bottom Alt",
    onChange: function onChange(e) {
      return _onChange({
        smallPanelImageBottomAlt: e.target.value
      });
    },
    value: smallPanelImageBottomAlt
  }), /*#__PURE__*/_react["default"].createElement(_TextInput["default"], {
    label: "Small Panel Image Bottom Link",
    onChange: function onChange(e) {
      return _onChange({
        smallPanelImageBottomLink: e.target.value
      });
    },
    value: smallPanelImageBottomLink
  }), /*#__PURE__*/_react["default"].createElement(_Checkbox["default"], {
    label: "External Link",
    checked: smallPanelImageBottomLinkExternal,
    onChange: function onChange(e) {
      return _onChange({
        smallPanelImageBottomLinkExternal: e.target.checked
      });
    }
  })));
};

var _default = PanelsForm;
exports["default"] = _default;